<template>
  <el-container class="relative table-page no-shrink-mobile">
    <aside class="filters-bar el-aside d-flex column sidebar-links">
      <router-link :to="'/class/'+$route.params.id">Students</router-link>
      <router-link :to="'/assessment/'+$route.params.id">Assessment</router-link>
      <div class="disabled-wrap"><router-link :to="'/analytics/'+$route.params.id" class="d-flex"><span>Analytics</span>
        <div class="premium"><img src="/static/premium.svg" alt=""><span>premium</span></div>
      </router-link></div>
      <div :class="{'disabled-wrap': (currentClass.demos && !currentClass.demos.length)}">
        <router-link :to="'/tours/'+$route.params.id"><span>Tours</span></router-link>
      </div>
    </aside>
    <div class="el-main" v-if="result">
      <div class="headings">
        <h2 style="margin-top: 0;">Student: {{ result.student.name }} ({{ result.class.name }})</h2>
          <h3 style="margin: 0" v-if="result.demo">Tour: {{result.demo.title}}</h3>
      </div>
      <results-table :label-quiz="labelQuiz" :slide-quiz="slideQuiz" :result="result"/>
    </div>
  </el-container>
</template>

<script>

  import ResultsTable from "../components/results-table.vue";

  export default {
    components: {ResultsTable},
    name: 'Result',
    data () {
      return {
        quiztypes: {
          radio: "Select right answer!",
          text: "Fill in the blank!",
          bool: "Choose if true!",
          drag: "Choose the right order!",
          textarea: "Write short answer!",
          select: "Find the parts!",
          isolated: "Name isolated part!",
          draglabels: "Drag labels to right parts!",
          connect: "Connect the parts!",
        },
        result: null,
        labelQuiz: [],
        slideQuiz: [],
        currentClass: false,
      }
    },
    mounted: function () {
      this.axios.get(this.$store.state.API_URL+'result/'+this.$route.params.result_id)
          .then((res) => {
            this.result = res.data;
            this.labelQuiz = Object.values(JSON.parse(res.data.labelQuiz)).filter( (q) => {return q.active});
            this.slideQuiz = JSON.parse(res.data.slideQuiz).filter( q => (q && q.active) );
          });
    },
    methods: {
      handleView(index, row) {
        console.log(index, row);
        this.$router.push('/assessment/'+row.class.id+'/'+row.id);
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/Result.vue